<div class="dialog-content">
  <img src="/assets/icons/info.svg" alt="" />
  <span class="header">{{ data.type }}</span>
  <p>{{ data.message }}</p>
  <div mat-dialog-actions class="text">
    <span (click)="close('ok')">{{ data?.yes }}</span>
    @if(data?.no) {
    <span (click)="close('cancel')">{{ data?.no }}</span>
    }
  </div>
</div>
